/**
 * Human-readable invoice copy only; billing must continue using numeric hours.
 * Keep the same output in the API and app until shared packages are available.
 */
export function formatBillableDuration(hours: number | string | null | undefined): string {
    const parsedHours = Number(hours);
    const numericHours = Number.isFinite(parsedHours) ? Math.max(0, parsedHours) : 0;
    const totalMinutes = Math.round(numericHours * 60);
    const wholeHours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const decimalHours = Number(numericHours.toFixed(4));
    const approximate = Math.abs(decimalHours - numericHours) > 0.00000001 ? '≈ ' : '';

    return `${wholeHours} ${wholeHours === 1 ? 'hour' : 'hours'} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} (${approximate}${decimalHours} ${decimalHours === 1 ? 'hour' : 'hours'})`;
}
